import { RefObject, useEffect } from 'react'

/**
 * Hook для обработки клика вне элемента
 */
export const useClickOutside = (refs: RefObject<HTMLElement>[], handler: () => void) => {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const target = event.target as Node

			// Проверяем, что клик произошел вне всех указанных элементов
			const isOutside = refs.every(ref => ref.current && !ref.current.contains(target))

			if (isOutside) {
				handler()
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [refs, handler])
}
